var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{attrs:{"id":"feedback-detail","modifier":"testimonial"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var close = ref.close;
var options = ref.options;
return [_c('div',{staticClass:"close",on:{"click":close}},[_c('SvgIcon',{attrs:{"name":"close"}})],1),(options)?_c('TestimonialCard',{attrs:{"modifier":"full","data":options}}):_vm._e()]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }